import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

/**
 * @typedef {'REG'|'MARGIN'} AccountType
 * @typedef {'SELL'|'BUY'} OrderSide
 * @typedef {'PRICE'|'VOLUME'} OrderCriterion
 * @typedef {'GTE'|'LTE'} OrderComparator
 * @typedef {'OPEN'|'EXPIRED'|'PAUSED'|'MATCHED'} OrderStatus
 * @typedef {'0RG'|'0RG'} OrderBoard
 * @typedef {'day'|'sesi'} OrderPeriod
 */

/**
 * @typedef   {object} AutoOrderParams
 * @property  {number} pageSize
 * @property  {AccountType} accountType
 */

/**
 * @typedef {object} AutoOrder
 *
 * @property {number}           id
 * @property {string}           code
 * @property {OrderSide}        side
 * @property {OrderCriterion}   criterion
 * @property {OrderComparator}  comparator
 * @property {number}           value
 * @property {number}           order_price
 * @property {number}           lot
 * @property {OrderBoard}       board
 * @property {OrderPeriod}      period
 * @property {number}           share_num
 * @property {OrderStatus}      order_status
 * @property {string}           start_date
 * @property {string}           end_date
 * @property {string}           note
 * @property {AccountType}      account_type
 */

/**
 * @typedef {object} AutoOrderData
 *
 * @property {number}       count
 * @property {string}       next
 * @property {string}       previous
 * @property {AutoOrder[]}  results
 */

/**
 * @typedef {object} AutoOrderResponse
 *
 * @property {AutoOrderData} data
 * @property {string} status
 * @property {string} statusText
 */

function getUrl() {
  return 'v1/stock/auto-trading/';
}

/**
 *
 * @param {string}          url
 * @param {AutoOrderParams} params
 * @returns
 */

function callbackFetch(url, { pageSize, accountType }) {
  return async ({ pageParam = 1 }) => {
    try {
      /**
       * @type {AutoOrderResponse}
       */
      const res = await fetcher.get(url, {
        params: {
          page: pageParam,
          page_size: pageSize,
          account_type: accountType,
        },
      });

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export default function getV1StockAutoOrder({ pageSize = 10, accountType = 'REG' } = {}) {
  const url = getUrl();
  const cb = callbackFetch(url, { accountType, pageSize });
  const key = [url, accountType, pageSize];

  return { cb, key };
}
